import React from 'react';
import ScrollAnimation from 'react-animate-on-scroll';
import * as styles from './animations.module.styl';

export default function FadeIn({ children, style = {} }) {
  return (
    <ScrollAnimation animateIn={styles.fadeIn} style={style} animateOnce>
      {children}
    </ScrollAnimation>
  );
}
